import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';


const ParkSeoWoo = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "유태규♡박서우 결혼합니다.";
    const openDesc = "2025년 05월 31일 오전 11시";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/211/thumb.jpg";

    const placeTelNum = "031-703-0116";

    const lng = 127.111455922512;
    const lat = 37.4005276924905;


    // const parents = [
    //     {groom : "명남식 · 故안인순의 아들"},
    //     {bride : "이금하 · 구은숙의 딸"}
    // ]

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const forBus = " ·  동안교 정류장 하차 후 도보 2분. [390]\n ·  국무역정보통신 하차 후 도보 2분. [4000 수원-성남]\n ·  차그룹컨소시엄 하차 후 도보 3분. [101,330,350,390]";
    const forCar = " ·  경부고속도로 : 판교IC(톨게이트) 차출 후 좌회전 \n→ 약 700m 직진하여 사거리에서 우회전. (SK주유소 뒤)\n\n ·  분당,수서간 도시고속도로 : 성남아트센터방면 지하차도 \n옆길 → 벌말사거리에서 우회전 → 삼성테크원 삼거리에서 \n판교역방면으로 좌회전"
    const forSubway = " ·  추천 최단거리 : '신분당선 판교역 , 경강선 판교역' 1번 \n출구로 나온 후, 직진 도보 6분. (SK주유소 뒷 건물)\n\n ·  야탑역 출발 단거리 : 330번 버스 탑승하여 \n차그룹컨소시엄 정류장 하차 후, 도보 3분. (총 약 20분)";
    const forShuttleBus = "판교역 1번 출구 셔틀버스 운행. "

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #EFD140
    // #EB9217
    // #ff8faf
    // #E36402
    // #88abd1
    // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf
  //  #E2396A
  // #F77BAD
      // #ffb0d2 쿨 연핑크
      const conceptStyle = {
        // 핑크A
        concept: "SPRING",
        titleColor: "#FF8A83",
        pointColor: "#FF8A83",
        btnBgColor: "#FFE8E7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fefaf9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "♡ 저희 결혼합니다 ♡";

    const msg1 = "포근함이 무던하던 봄날 , 화창한 여름 햇빛 아래 \n사랑스러운 외동으로 태어나 자라온 그 둘이\n서로의 손을 잡고 함께 걸어가려 합니다.\n소중한 분들과 함께라면 저희에겐 더없는 기쁨이 될 것입니다.";

    const groomAccountList = [
        {
            role: "신랑",
            name: "유태규",
            bank: "국민은행",
            accountNumber : "584101-01-061839",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "유진영",
            bank: "우리은행",
            accountNumber : "1002-215 -054965",
            isKakao :  false
        }
        ,{
            role: "신랑 모",
            name: "박귀향",
            bank: "농협은행",
            accountNumber : "312-0093-7782-41",
            isKakao :false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박서우",
            bank: "우리은행",
            accountNumber : "1002-048-338415",
            isKakao : false
        }
        // ,{
        //     role: "신부 부",
        //     name: "김재진",
        //     bank: "신한은행",
        //     accountNumber : "110407983960",
        //     isKakao :false
        // }
        // ,{
        //     role: "신부 모",
        //     name: "나은숙",
        //     bank: "하나은행",
        //     accountNumber : "44191025134807",
        //     isKakao : false
        // }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "유태규",
            call: "01077589449"
        }
        ,{
            role: "신랑 부",
            name: "유진영",
            call: "01054433474"
        }
        ,{
            role: "신랑 모",
            name: "박귀향",
            call: "01090838822"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "박서우",
            call: "01066740087"
        }
        ,{
            role: "신부 부",
            name: "박성준",
            call: "01042870008"
        },
        {
            role: "신부 모",
            name: "박순영",
            call: "01043560088"
        }
    ]

    const interviewContent = [
        {
            question : "누나 동생 사이였다가 만나게 되었을 때 어땠어?",
            groomAnswer: "어색했어",
            brideAnswer: "색다로웠어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "기대하고있어",
            brideAnswer: "엄청 기대돼!"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "재밌게살자",
            brideAnswer: "평생잘부탁해"
        },
        {
            question : "상대가 가장 사랑스러워 보일 때는?",
            groomAnswer: "애교부릴때",
            brideAnswer: "예쁘게말할때"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "평생사랑해♡",
            brideAnswer: "많이사랑해♡"
        }
    ]


    const informationList =[
        {
            title : "화환 안내",
            content : "화환은 정중히 사양합니다. \n축하해 주시는 마음만 받겠습니다 :)"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                            <Information pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} />
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forSubway={forSubway} forBus={forBus} forCar={forCar} forShuttleBus={forShuttleBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkSeoWoo;